// @flow

import { getComponentSettings } from './main';

import { type State } from '../reducers';

type GlobalState = {
  componentSettings: State,
};

export type FeedbackSettings = $PropertyType<State, 'feedback'>;
export const getFeedbackSettings = (state: GlobalState) => {
  const { feedback } = getComponentSettings(state);
  if (!feedback) {
    throw new Error('Missing feedback settings in componentSettings store.');
  }
  return feedback;
};

export const getTitle = (state: GlobalState) => (
  getFeedbackSettings(state).title
);

export const getFeedbackWasHelpful = (state: GlobalState) => (
  getFeedbackSettings(state).true
);

export const getFeedbackWasNotHelpful = (state: GlobalState) => (
  getFeedbackSettings(state).false
);

export const getFeedbackWasPartiallyHelpful = (state: GlobalState) => (
  getFeedbackSettings(state).partial
);
